<template>
    <b-row>
        <b-col md="3" lg="3" sm="3" class="input-group input-group-sm p-2">
            <input type="search" name="table_search" class="form-control" placeholder="Buscar" v-model="filtros.search" @input="debouncedGetControlAcessos"/>

            <div class="input-group-append">
                <Button @click="debouncedGetControlAcessos" type="submit" variant="default" icon="fas fa-search" />
            </div>
        </b-col>
        <b-col md="9" lg="9" sm="9">
            <select class="custom-select w-auto mr-3" v-model="filtros.status" @change="debouncedGetControlAcessos">
                <option value="">Seleciona Estado</option>
                <option value="1">Validada</option>
                <option value="0">No validada</option>
            </select>
            <select class="custom-select w-auto mr-3" v-model="filtros.metodo_pago" @change="debouncedGetControlAcessos" v-if="metodos_pagos">
                <option value="">Metodo de Pago</option>
                <option v-for="metodo in metodos_pagos" :value="metodo.id" :key="metodo.id">{{ metodo.nombre }}</option>
            </select>
        </b-col>

        <b-col lg="12">
            <b-table hover :items="controlAcessos.data" :fields="fields" id="listado-control-accesos-entradas" v-if="!loading"/>
            <div v-else class="d-flex justify-content-center">
                <b-spinner label="Loading..."/>
            </div>
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent @input="(n) => filtros.numPage = n" :value="filtros.numPage" @change="setPaguinacion"/>
                </div>
                <div class="col-12 col-lg-4">
                    <PaginateComponent :current_page="controlAcessos.meta.current_page" :last_page="controlAcessos.meta.last_page" v-on:change_page="setPage"/>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent.vue';
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    export default {
        props: ['fields', 'controlAcessos' , 'filtros', 'loading', 'metodos_pagos'],
        data() {
            return {
                debouncedGetControlAcessos: null,
            }
        },
        created() {
            this.$emit('getcontrolAcessos');
            this.debouncedGetControlAcessos = _.debounce(this.getcontrolAcessos, 1000);
        },
        methods: {
            getcontrolAcessos(){
                this.$emit('getcontrolAcessos');
            },
            setPage(page) {
                this.filtros.page = page;
                this.$emit('getcontrolAcessos');
            },
            setPaguinacion(){
                this.filtros.page = 1;
                this.$emit('getcontrolAcessos');
            }
        },
        watch: {
            'filtros.status'() {
                this.filtros.page = 1;
            },
            'filtros.metodo_pago'() {
                this.filtros.page = 1;
            }
        
        },
        components: {
            ElementosPorPaginaComponent, PaginateComponent
        },
    }
</script>